import InstancesContainer from "InstanceManagement/Components/InstancesContainer";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const InstanceManagementPage: React.FunctionComponent = () => {
	return (
		<AuthenticatedLayout title="Správa instancí">
			<InstancesContainer />
		</AuthenticatedLayout>
	);
};
